import React from 'react';
import { Tooltip } from 'antd';
import { formatToken } from './formatToken';

export interface MessageTokens {
  input?: number;
  complete?: number;
  cache?: number;
  total?: number;
}

interface TokenTagProps {
  total: number;
  input?: number;
  output?: number;
  cache?: number;
  variant: 'message' | 'session';
}

const numOrZero = (n?: number) => (typeof n === 'number' && Number.isFinite(n) && n > 0 ? n : 0);

function renderRow(label: string, value: number, pctBase: number) {
  const showPct = pctBase > 0;
  return (
    <div
      key={label}
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 12,
        fontSize: 12,
        lineHeight: 1.6,
        whiteSpace: 'nowrap'
      }}
    >
      <span style={{ color: '#8C8C8C', minWidth: 48 }}>{label}</span>
      <span style={{ color: '#262626', fontVariantNumeric: 'tabular-nums' }}>
        {formatToken(value)}
        {showPct && <span style={{ color: '#8C8C8C', marginLeft: 6 }}>({Math.round((value / pctBase) * 100)}%)</span>}
      </span>
    </div>
  );
}

export default function TokenTag({ total, input, output, cache, variant }: TokenTagProps) {
  if (!(total > 0)) return null;
  const inputN = numOrZero(input);
  const outputN = numOrZero(output);
  const cacheN = numOrZero(cache);
  const pctBase = inputN + outputN;
  const label = `${formatToken(total)} Tokens`;

  const tooltipContent = (
    <div style={{ padding: '2px 0' }}>
      {renderRow('Input', inputN, pctBase)}
      {renderRow('Output', outputN, pctBase)}
      {cacheN > 0 && renderRow('Cache', cacheN, pctBase)}
    </div>
  );

  const tagStyle: React.CSSProperties =
    variant === 'message'
      ? {
          display: 'inline-flex',
          alignItems: 'center',
          padding: '1px 8px',
          fontSize: 11,
          lineHeight: 1.5,
          color: '#595959',
          background: '#FAFAFA',
          border: '1px solid #E8E8E8',
          borderRadius: 4,
          cursor: 'default',
          userSelect: 'none'
        }
      : {
          display: 'inline-flex',
          alignItems: 'center',
          fontSize: 12,
          lineHeight: 1.4,
          color: '#8C8C8C',
          cursor: 'default',
          userSelect: 'none'
        };

  return (
    <Tooltip title={tooltipContent} placement="top" color="#fff" overlayInnerStyle={{ color: '#262626' }} zIndex={1200}>
      <span style={tagStyle}>{label}</span>
    </Tooltip>
  );
}
